import { GetInfoForBookingRequest } from '@/api/generated/fetch-client';
import { WithRepository } from '@/types/typings';
import { formatDateForBackend } from '@/utils/format-date-for-backend';
import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';

import { OrderRepository } from '../repository/order-repository';
import { useOrderRepository } from '../repository/use-order-repository';

export function useGetPreorderInfo(params: GetInfoForBookingRequest) {
  const repository = useOrderRepository();
  return useSuspenseQuery(useGetPreorderInfo.options({ repository, ...params }));
}

useGetPreorderInfo.baseKey = 'Preorder';

useGetPreorderInfo.keys = (params: GetInfoForBookingRequest) =>
  [useGetPreorderInfo.baseKey, { ...params }] as const;

useGetPreorderInfo.options = ({
  repository,
  ...params
}: WithRepository<GetInfoForBookingRequest, OrderRepository>) =>
  queryOptions({
    queryKey: useGetPreorderInfo.keys(params),
    queryFn: ({ signal }) =>
      repository.getInfoForBooking({
        ...params,
        arrivalDate: formatDateForBackend(new Date(params.arrivalDate)),
        departureDate: formatDateForBackend(new Date(params.departureDate)),
        signal,
      }),
  });
